import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./style/hm1.css";
import "./style/home_body.css";
import "./style/service.css";
import "./style/hm_hb1.css";
import "./style/cr_1.css";
import App from "./app";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
